<div class="container mx-auto px-4 py-8">
  <!-- Page Header -->
  <div class="mb-8">
    <h1 class="text-3xl font-bold text-gray-900 mb-2">Kontakt</h1>
    <p class="text-gray-600">Unser Team steht Ihnen gerne zur Verfügung</p>
  </div>

  <!-- Error Message -->
  @if (errorMessage()) {
    <div class="rounded-md bg-red-50 p-4 mb-6">
      <p class="text-sm font-medium text-red-800">{{ errorMessage() }}</p>
    </div>
  }

  <!-- Loading State -->
  @if (isLoading()) {
    <div class="text-center py-12">
      <p class="text-gray-500">Lädt Teamdaten...</p>
    </div>
  }

  <!-- Team Members Grid -->
  @if (!isLoading() && teamMembers().length > 0) {
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      @for (member of teamMembers(); track member.Id) {
        <div class="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden">
          <!-- Image -->
          <div class="w-full h-48 bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center overflow-hidden">
            <img
              [src]="getAvatarUrl(member)"
              [alt]="member.Name"
              class="w-full h-full object-cover"
            />
          </div>

          <!-- Content -->
          <div class="p-4">
            <!-- Role -->
            <p class="text-xs font-semibold text-blue-600 uppercase tracking-wide mb-1">
              {{ member.Role }}
            </p>

            <!-- Name -->
            <h3 class="text-lg font-bold text-gray-900 mb-3">
              {{ member.Name }}
            </h3>

            <!-- Email -->
            <a
              [href]="'mailto:' + member.Email"
              class="inline-flex items-center text-sm text-gray-600 hover:text-blue-600 transition-colors"
            >
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
              {{ member.Email }}
            </a>
          </div>
        </div>
      }
    </div>
  }

  <!-- Empty State -->
  @if (!isLoading() && teamMembers().length === 0 && !errorMessage()) {
    <div class="text-center py-12">
      <p class="text-gray-500">Keine Teammitglieder verfügbar</p>
    </div>
  }
</div>
